"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const ColumnIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "-434 236 90 90" }),
    react_1.default.createElement("path", { d: "M-357.8,250.6h-4.6h-53.2h-4.6c-1,0-1.8,0.8-1.8,1.8v4.6V305v4.6c0,1,0.8,1.8,1.8,1.8h4.6h53.2h4.6c1,0,1.8-0.8,1.8-1.8V305  V257v-4.6C-356.1,251.3-356.9,250.6-357.8,250.6z M-391.5,306.3h-24c-0.3,0-0.6-0.1-0.9-0.4s-0.4-0.6-0.4-0.9v-44.3h25.3V306.3z   M-386.5,306.3v-45.6h25.3v44.3c0,0.3-0.1,0.6-0.4,0.9s-0.5,0.4-0.9,0.4L-386.5,306.3L-386.5,306.3z" })));
exports.ColumnIcon = ColumnIcon;
exports.default = exports.ColumnIcon;
